import React, { useState, useEffect } from "react";

function MailIcon() {
  const [isOverEmail, setOverEmail] = useState();

  return (
    <div
      onMouseEnter={() => setOverEmail(true)}
      onMouseLeave={() => setOverEmail(false)}
      onMouseDown={() => setOverEmail(true)}
      onMouseUp={() => {
        setTimeout(() => {
          setOverEmail(false);
        }, 500);
      }}
    >
      <svg
        width="18px"
        height="15px"
        viewBox="0 0 18 15"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        className={`${isOverEmail ? "hovered" : "normal"}`}
      >
        {/* <title pointer-events="none">ic/mail</title> */}
        <defs>
          <filter colorInterpolationFilters="auto" id="filter-1">
            <feColorMatrix
              in="SourceGraphic"
              type="matrix"
              values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
            ></feColorMatrix>
          </filter>
          <filter colorInterpolationFilters="auto" id="filter-2">
            <feColorMatrix
              in="SourceGraphic"
              type="matrix"
              values="0 0 0 0 1.000000 0 0 0 0 0.411765 0 0 0 0 0.380392 0 0 0 1.000000 0"
            ></feColorMatrix>
          </filter>
        </defs>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          opacity="0.800000012"
        >
          <g
            id="428x926---iPhone-13ProMax-Copy"
            transform="translate(-23.000000, -880.000000)"
          >
            <g
              id="ic/mail"
              transform="translate(21.000000, 876.000000)"
              filter="url(#filter-1)"
            >
              <g filter="url(#filter-2)" id="mail">
                <g transform="translate(2.750000, 4.583333)">
                  <path
                    d="M16.4890143,2.8090699 L16.5,1.49278611 C16.5,0.668768186 15.8847945,0 15.1247138,0 L1.37459947,0 C0.615205372,0 0,0.668768186 0,1.49278611 L0,2.72771305 L7.84234115,6.24109128 C8.09989364,6.3564751 8.39421028,6.35765868 8.65268244,6.24435001 L16.4890143,2.8090699 L16.4890143,2.8090699 Z"
                    id="Combined-Shape-path"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                  ></path>
                  <path
                    d="M0.0109858103,4.58333333 L0,12.3095245 C0,13.1046674 0.615891995,13.75 1.37459946,13.75 L15.1247147,13.75 C15.8847955,13.75 16.5,13.1046674 16.5,12.3095245 L16.4890142,4.58333333 L8.65813326,8.08758351 C8.39823439,8.20388596 8.10108132,8.20388135 7.84118606,8.08757082 L0.0109858103,4.58333333 L0.0109858103,4.58333333 Z"
                    id="Combined-Shape-path"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
}

export default MailIcon;

